<!-- FILE: src/app/features/calendar/appointment-history/appointment-history.component.html -->

<div class="history-page">

  <!-- ── Header strip ──────────────────────────────────────────────── -->
  <div class="history-header">
    <button class="back-btn" (click)="goBack()">
      <i class="fa fa-angle-left"></i>
    </button>

    <span class="header-title">Appointments History</span>

    <ng-container *ngIf="lawyerName">
      <span class="header-sep">-</span>
      <div class="header-avatar"
           *ngIf="!lawyerProfilePic || lawyerProfilePic === 'PROFILE_IMAGE' || lawyerProfilePic === ''">
        {{ lawyerInitials }}
      </div>
      <img *ngIf="lawyerProfilePic && lawyerProfilePic !== 'PROFILE_IMAGE' && lawyerProfilePic !== ''"
           [src]="lawyerProfilePic" [alt]="lawyerName" class="header-avatar-img" />
      <span class="header-lawyer-name">{{ lawyerName }}</span>
    </ng-container>
  </div>

  <!-- ── Loader ────────────────────────────────────────────────────── -->
  <div class="history-loader" *ngIf="isLoading">
    <div class="spinner"></div>
    <p>Loading history...</p>
  </div>

  <!-- ── Empty state ───────────────────────────────────────────────── -->
  <div class="history-empty" *ngIf="!isLoading && historyItems.length === 0">
    <i class="bi bi-calendar-x empty-icon"></i>
    <p class="empty-title">No Appointment History Available</p>
    <p class="empty-sub">Your past appointments with this lawyer will appear here.</p>
  </div>

  <!-- ── Scrollable area with single white container ───────────────── -->
  <div class="history-scroll-area" *ngIf="!isLoading && historyItems.length > 0">
    <div class="timeline-container">

      <div class="timeline-item"
           *ngFor="let item of historyItems; let i = index; let last = last">

        <!-- Dot + vertical line -->
        <div class="timeline-indicator-col">
          <div class="timeline-dot-wrapper" [ngClass]="getStatusClass(item.appointment_status)">
            <div class="timeline-dot-outer">
              <div class="timeline-dot-inner"></div>
            </div>
          </div>
          <div class="timeline-line" *ngIf="!last"></div>
        </div>

        <!-- Content -->
        <div class="timeline-content-col">
          <div class="appointment-ordinal">{{ getOrdinal(historyItems.length - i) }} Appointment</div>
          <div class="card-datetime">{{ formatDateRange(item.appointment_from, item.appointment_to) }}</div>
          <div class="card-payment">{{ getPaymentLabel(item) }}: ₹ {{ getPaymentAmount(item) }}</div>
          <span class="status-badge" [ngClass]="getStatusClass(item.appointment_status)">
            {{ getStatusLabel(item.appointment_status) }}
          </span>
        </div>

      </div>

    </div>
  </div>

</div>